"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowUpLine = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowUpLine"));

// Generated by script, don't edit it please.
var ArrowUpLine = (0, _createSvgIcon["default"])({
  as: _ArrowUpLine["default"],
  ariaLabel: 'arrow up line',
  category: 'direction',
  displayName: 'ArrowUpLine'
});
var _default = ArrowUpLine;
exports["default"] = _default;
module.exports = exports.default;